module Meevo.Plugins.CultureSettings {
    "use strict";

    /**
    * Main Section of Culture Settings 
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        
        excludeCountryList = [Meevo.Model.CountryEnum.Other];
        protected languageIdList: Model.DataDetail[];
        protected languageId: Model.DataDetail;
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            sectionSecurityKey: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
            this.languageIdList = [{ id: 'fr-CH', displayName: 'LABEL_FRENCH' }, { id: 'de-CH', displayName: 'LABEL_GERMAN' }]
        }

        activate(): void {
            super.activate();
            if (Model.Guard.isSomething(this.model)) {
                var that = this;
                that.languageId = { id: this.model.locale}
            }
        }

        update(): void {
            let cultureModel = <Meevo.Model.CulturalSettings>this.model;
            let countryId = Meevo.Model.CountryIdEnum[cultureModel.countryEnum].substr(3).toUpperCase();
            cultureModel.currencyCodeEnum = parseInt(Meevo.Model.CurrencyEnum[this.appSettings.APP_COUNTRIES[countryId]["IsoCurrencyCode"]]);
            cultureModel.locale = Meevo.Model.CountryIdEnum[cultureModel.countryEnum].replace('_', '-');
            var that = this;
            if (cultureModel.countryEnum == 30295) {
                that.languageId = { id: this.languageIdList[1].id };
                cultureModel.locale = that.languageId.id;
            } else {
                that.languageId = { id: cultureModel.locale }

            }
        }
        updateLangId(): void {
            var that = this;
            var langId = that.languageId;
            let cultureModel = <Meevo.Model.CulturalSettings>this.model;
            cultureModel.locale = that.languageId.id;
        }
    }
}